"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCombinedErrorMessage = exports.defaultErrorTranslator = exports.defaultTranslator = exports.getI18nKey = void 0;
var util_1 = require("../util");
var getI18nKey = function (schema, uischema, key) {
    var _a;
    if ((_a = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _a === void 0 ? void 0 : _a.i18n) {
        return uischema.options.i18n + "." + key;
    }
    if (schema === null || schema === void 0 ? void 0 : schema.i18n) {
        return schema.i18n + "." + key;
    }
    return undefined;
};
exports.getI18nKey = getI18nKey;
var defaultTranslator = function (_id, defaultMessage) { return defaultMessage; };
exports.defaultTranslator = defaultTranslator;
var defaultErrorTranslator = function (error, t, uischema) {
    // check whether there is a special keyword message
    var keyInSchemas = exports.getI18nKey(error.parentSchema, uischema, "error." + error.keyword);
    var specializedKeywordMessage = keyInSchemas && t(keyInSchemas, undefined);
    if (specializedKeywordMessage !== undefined) {
        return specializedKeywordMessage;
    }
    // check whether there is a generic keyword message
    var genericKeywordMessage = t("error." + error.keyword, undefined);
    if (genericKeywordMessage !== undefined) {
        return genericKeywordMessage;
    }
    // check whether there is a customization for the default message
    var messageCustomization = t(error.message, undefined);
    if (messageCustomization !== undefined) {
        return messageCustomization;
    }
    // rewrite required property messages (if they were not customized) as we place them next to the respective input
    if (error.keyword === 'required') {
        return t('is a required property', 'is a required property');
    }
    return error.message;
};
exports.defaultErrorTranslator = defaultErrorTranslator;
/**
 * Returns the determined error message for the given errors.
 * All errors must correspond to the given schema and uischema.
 */
var getCombinedErrorMessage = function (errors, et, t, schema, uischema) {
    if (errors.length > 0 && t) {
        // check whether there is a special message which overwrites all others
        var keyInSchemas = exports.getI18nKey(schema, uischema, 'error.custom');
        var specializedErrorMessage = keyInSchemas && t(keyInSchemas, undefined);
        if (specializedErrorMessage !== undefined) {
            return specializedErrorMessage;
        }
    }
    return util_1.formatErrorMessage(errors.map(function (error) { return et(error, t, uischema); }));
};
exports.getCombinedErrorMessage = getCombinedErrorMessage;
//# sourceMappingURL=i18nUtil.js.map